import React, { Component } from 'react';
export class OneImgWithIntro extends Component {

  render() {
    const {id, style} = this.props
    const customAttributes = {
      id, style
    };
    return (
      <div {...customAttributes}>{this.props.children}</div>
    );
  }
}


export default OneImgWithIntro;
